import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const preOrderPickupFormDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.preOrderPickup,
  componentType: LAYOUT_COMPONENT_TYPE.preOrderPickupForm,
  registryBlockKey: REGISTRY_BLOCK.presentation.preOrderPickupForm,
  displayOrder: 7,
  content: {
    heading: loc3('Vorbestellen & Abholen', 'Pre-order & pickup', 'Đặt trước & nhận'),
    supporting: loc3(
      'Bestellung bis 10 Uhr — Abholung am selben Tag.',
      'Order by 10am — same-day pickup.',
      'Đặt trước 10 giờ — nhận trong ngày.',
    ),
    ctaLabel: loc3('Bestellung senden', 'Send order', 'Gửi đơn'),
    note: loc3(
      'Große Bestellungen bitte einen Tag vorher.',
      'Large orders please one day ahead.',
      'Đơn lớn vui lòng trước một ngày.',
    ),
  },
  media: {},
};
